module.exports = __webpack_public_path__ + "media/assets/images/personas/beatrice-3277fa51070b5d548352f72d8a0cbc27.jpg";